module.exports = __webpack_public_path__ + "static/media/review-2.2a798fc9.png";